import { render, staticRenderFns } from "./keyword-picker.vue?vue&type=template&id=123a4256&scoped=true&"
import script from "./keyword-picker.vue?vue&type=script&lang=js&"
export * from "./keyword-picker.vue?vue&type=script&lang=js&"
import style0 from "./keyword-picker.vue?vue&type=style&index=0&id=123a4256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a4256",
  null
  
)

export default component.exports